import axios, { AxiosResponse, AxiosInstance, AxiosRequestConfig, CancelToken } from 'axios';
import { FavoriteListClient, CustomerAgreementClient, 
    OrderingListClient, OrderingListUserPermissionClient, OrderingListRequestProductClient,
    UserHierarchyClient } from 'Api/CoreApi';
    import { UserClient as DynamicwebApiClient } from './DynamicwebApi';
    import store from "Store/index";
    
    
    interface ICoreApiClient {
        FavoriteListClient: FavoriteListClient;
        CustomerAgreementClient: CustomerAgreementClient;
        OrderingListClient: OrderingListClient;
        UserPermissionClient: OrderingListUserPermissionClient
        
    }
    
    class ApiFactory {
        
        private _reCaptchaToken: string = '';
        
        private _apiUrl: string;
        private _cmsUrl: string = '';
        
        
        public setApiUrl(url: string) {
            this._apiUrl = url;
        }
        
        public setDwApi(url: string) {
            this._cmsUrl = url;
        }
        
        

        public setReCaptchaToken(token: string) {
            this._reCaptchaToken = token;
        }

        public getReCaptchaToken(): string{
            return this._reCaptchaToken;
        }
        

        private _getOrderingListRequestProductClient: OrderingListRequestProductClient;
        public async getOrderingListRequestProductClient(): Promise<OrderingListRequestProductClient> {
            await store.dispatch.auth.loadUser();
            if (!this._getOrderingListRequestProductClient) {
                this._getOrderingListRequestProductClient = new OrderingListRequestProductClient(this._apiUrl, this.getAxios()); 
            }
            return this._getOrderingListRequestProductClient; 
        }
        
        
        private _userPermissionsClient: OrderingListUserPermissionClient;
        public async getUserPermissionsClient(): Promise<OrderingListUserPermissionClient> {
            await store.dispatch.auth.loadUser()
            if (!this._userPermissionsClient) {
                this._userPermissionsClient = new OrderingListUserPermissionClient(this._apiUrl, this.getAxios()); 
            }
            return this._userPermissionsClient; 
        }
        
        
        
        
        private _orderingListClient: OrderingListClient;
        public async getOrderingListClient(): Promise<OrderingListClient> {
            await store.dispatch.auth.loadUser();
            if (!this._orderingListClient) {
                this._orderingListClient = new OrderingListClient(this._apiUrl, this.getAxios()); 
            }
            return this._orderingListClient; 
        }
        
        
        private _orderingListUserHierarchy: UserHierarchyClient;
        public async getOrderingListUserHierarchyClient(): Promise<UserHierarchyClient> {
            await store.dispatch.auth.loadUser()
            if (!this._orderingListUserHierarchy) {
                this._orderingListUserHierarchy = new UserHierarchyClient(this._apiUrl, this.getAxios()); 
            }
            return this._orderingListUserHierarchy; 
        }
        
        
        private _customerAgreementClient: CustomerAgreementClient;
        public async getCustomerAgreementClient(): Promise<CustomerAgreementClient> {
            await store.dispatch.auth.loadUser()
            if (!this._customerAgreementClient) {
                this._customerAgreementClient = new CustomerAgreementClient(this._apiUrl, this.getAxios()); 
            }
            return this._customerAgreementClient; 
        }
        
        
        private _favoriteListClient: FavoriteListClient;
        public async getFavoriteListClient(): Promise<FavoriteListClient> {        
            await store.dispatch.auth.loadUser();
            if (!this._favoriteListClient) {
                this._favoriteListClient = new FavoriteListClient(this._apiUrl, this.getAxios()); 
            }
            return this._favoriteListClient; 
        }
        
        
        private _dynamicwebClient: DynamicwebApiClient;
        public getDynamicwebClient(): DynamicwebApiClient {
            if (!this._dynamicwebClient) {
                this._dynamicwebClient = new DynamicwebApiClient(this._cmsUrl, this.getAxios()); 
            }
            return this._dynamicwebClient; 
        }
        
        
        private beforeSend(request: any) {
            console.log(request);
            if(store.state.auth.user && store.state.auth.user.token) {
                request.setRequestHeader('Authorization', 'Bearer ' + store.state.auth.user.token);
            }
        }
        
        private getAxios(): AxiosInstance {
            const ax = axios.create();
            
            //avoiding - cached headers
            ax.interceptors.request.use(req => {
                req.url += req.url.indexOf('?') > -1
                ? '&'
                : '?';
                
                req.url += '_ts=' + Math.random();
                return req;
            });
            
            ax.interceptors.request.use(config => {
                
                const token = () => {
                    if(store.state.auth.user)
                    return store.state.auth.user.token;
                    else
                    return '';
                }
                if (token()) {
                    config.headers['Authorization'] = `bearer ${token()}`;
                }
                return config;
            });
            return ax;
        }
        
        
        
        apiPath: string = 'handlers/orderDeliveryAddress.ashx';
        
        
        
        public async searchProducts(searchUrl: string, params: any, cancelToken: CancelToken){
            var response = await axios.get(searchUrl, <AxiosRequestConfig>{
                params: params,
                cancelToken: cancelToken
            });
            return response;
        }
        
        async deleteAddress(id: string) {
            var response = axios.post(`${this.apiPath}?action=delete&id=${id}`);
            
            response.then((reponse: any) => {
                //console.log('something happend');
            });
            
            response.catch((reason) => {
                //console.log('could not delete');
            });
            return response;
        }
    }
    export default new ApiFactory();
    
    //TODO: - check for NOT AUTHORIZED codes - and make a challenge (ONLY WEBAPI!!)
    
    //created: function () {
    //    axios.interceptors.response.use(undefined, function (err) {
    //        return new Promise(function (resolve, reject) {
    //            if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
    //                // if you ever get an unauthorized, logout the user
    //                this.$store.dispatch(AUTH_LOGOUT)
    //                // you can also redirect to /login if needed !
    //            }
    //            throw err;
    //        });
    //    });
    //}